export const CAMPOS_REGISTRO = [
  { name: 'Nombre Completo', section: 'Datos Personales' },
  { name: 'RUT', section: 'Datos Personales' },
  { name: 'Email', section: 'Datos Personales' },
  { name: 'Convocatoria', section: 'Datos Personales' },
  { name: 'Fecha de enrolamiento en convocatoria', section: 'Datos Personales' },
  { name: 'Celular emprendedor', section: 'Datos Personales' },
  { name: 'Estado de registro', section: 'Datos Personales' },
  { name: 'Estado', section: 'Datos Personales' },
  { name: 'Fecha de activación de mentor', section: 'Datos Personales' },
  { name: 'Role', section: 'Datos Personales' },
  { name: 'Nivel Educacional', section: 'Datos Personales' },
  { name: 'Sexo', section: 'Datos Personales' },
  { name: 'Fecha de Nacimiento', section: 'Datos Personales' },
  { name: 'Nacionalidad', section: 'Datos Personales' },
  { name: 'Ingreso mensual del hogar', section: 'Datos Personales' },
  { name: 'Registro social de hogares', section: 'Datos Personales' },
  { name: 'Región', section: 'Datos Personales' },
  { name: 'Comuna', section: 'Datos Personales' },
  { name: '¿Ha participado en procesos de mentoría?', section: 'Datos Personales' },
  { name: '¿Has realizado cursos online?', section: 'Datos Personales' },
  { name: 'Tiene horarios', section: 'Datos Personales' },
  { name: 'Fecha de Registro', section: 'Datos Personales' },
  { name: 'Nombre del emprendimiento', section: 'Datos de Empresa' },
  { name: '¿Está formalizado?', section: 'Datos de Empresa' },
  { name: '¿Cuál es la forma jurídica de tu empresa u organización?', section: 'Datos de Empresa' },
  { name: '¿Por qué no estás formalizado?', section: 'Datos de Empresa' },
  { name: '¿Qué año formalizaste este emprendimiento?', section: 'Datos de Empresa' },
  { name: 'RUT de empresa', section: 'Datos de Empresa' },
  { name: '¿Vendes Productos o Ofreces Servicios?', section: 'Datos de Empresa' },
  { name: 'Indique el rubro de su empresa', section: 'Datos de Empresa' },
  { name: '¿A qué tipo de clientes atiendes?', section: 'Datos de Empresa' },
  { name: 'Cantidad de empleados en la Emprendimiento/Pyme', section: 'Datos de Empresa' },
  { name: 'Sitio web', section: 'Datos de Empresa' },
  { name: 'Facebook', section: 'Datos de Empresa' },
  { name: 'Instagram', section: 'Datos de Empresa' },
  { name: 'LinkedIn', section: 'Datos de Empresa' },
  { name: 'TikTok', section: 'Datos de Empresa' },
  { name: '¿Qué año partiste este emprendimiento?', section: 'Datos de Empresa' },
  { name: '¿Cuál es el tamaño de tu Emprendimiento/Pyme?', section: 'Datos de Empresa' },
  { name: 'Cuéntanos sobre tu negocio', section: 'Datos de Empresa' },
  { name: 'Profesión u oficio', section: 'Datos de Mentor' },
  { name: '¿En qué año realizaste tu primera mentoría?', section: 'Datos de Mentor' },
  { name: 'Pilares de mentoría', section: 'Datos de Mentor' },
  { name: 'Descripción de temas en que puede aportar', section: 'Datos de Mentor' },
  { name: '¿Cómo te enteraste de ChileConverge?', section: 'Datos de Mentor' },
  { name: 'Mini reseña', section: 'Datos de Mentor' },
  { name: 'LinkedIn del mentor', section: 'Datos de Mentor' },
  { name: 'Instagram del mentor', section: 'Datos de Mentor' },
  { name: '¿Te gustaría participar en el chat de WhatsApp de mentores?', section: 'Datos de Mentor' },
  { name: '¿Podemos compartir tu información de contacto?', section: 'Datos de Mentor' },
];

export const CAMPOS_ACTIVIDAD = [
  { name: 'Accesos a plataforma', section: 'Actividad' },
  { name: 'Cantidad de Cursos - Inscritos', section: 'Actividad' },
  { name: 'Cantidad de Cursos - Aprobados', section: 'Actividad' },
  { name: 'Cantidad de Cursos - En proceso', section: 'Actividad' },
  { name: 'Cantidad de Mentorías - Realizadas', section: 'Actividad' },
  { name: 'Cantidad de Mentorías - Canceladas', section: 'Actividad' },
  { name: 'Cantidad de Mentorías - Abandonadas', section: 'Actividad' },
  { name: 'Cantidad de talleres vistos', section: 'Actividad' },
];

// No se muestran al crear reportes nuevos, pero deben sobrevivir al editar,
// duplicar o ejecutar configuraciones guardadas antes del rediseño.
const HISTORICAL_REGISTRY_FIELD_NAMES = [
  '¿Te identificas como una persona en situación de discapacidad?',
  'Pueblo originario al que pertenece',
  '¿Perteneces a la comunidad LGBTQ+?',
  'Etapa del emprendimiento',
  'Número de socios',
  '¿Opera en su hogar?',
  '¿Ha tenido ventas?',
  'Facturación últimos 12 meses',
  'Horas dedicadas al negocio',
  '¿Cuántos clientes ha tenido?',
  '¿Surgió por necesidad económica?',
];

const LEGACY_FIELD_ALIASES = {
  '¿Tiene discapacidad?': '¿Te identificas como una persona en situación de discapacidad?',
  '¿Perteneces a la comunidad LGTB+?': '¿Perteneces a la comunidad LGBTQ+?',
  'Nombre empresa': 'Nombre del emprendimiento',
  'Rut empresa': 'RUT de empresa',
  'Tipo empresa': '¿Cuál es el tamaño de tu Emprendimiento/Pyme?',
  'Tamaño de empresa': '¿Cuál es el tamaño de tu Emprendimiento/Pyme?',
  'Tipo de formalización': '¿Cuál es la forma jurídica de tu empresa u organización?',
  '¿Qué tipo legal?': '¿Cuál es la forma jurídica de tu empresa u organización?',
  'Año de formalización': '¿Qué año formalizaste este emprendimiento?',
  'Motivo de no formalización': '¿Por qué no estás formalizado?',
  'Cantidad de empleados': 'Cantidad de empleados en la Emprendimiento/Pyme',
  'Sitio/Dominio Web': 'Sitio web',
  'Sitio / Dominio Web': 'Sitio web',
  'Rubro': 'Indique el rubro de su empresa',
  'Rubro empresa': 'Indique el rubro de su empresa',
  'Servicios/productos': 'Indique el rubro de su empresa',
  'LinkedIn Empresa': 'LinkedIn',
  'Modelo de negocio (b2b o b2c)': '¿A qué tipo de clientes atiendes?',
  '¿A qué tipo de clientes atiendes? (Puedes seleccionar más de una)': '¿A qué tipo de clientes atiendes?',
  '¿Cuántos años tiene tu negocio?': '¿Qué año partiste este emprendimiento?',
  '¿Qué año partiste tu emprendimiento?': '¿Qué año partiste este emprendimiento?',
  'Acerca de': 'Cuéntanos sobre tu negocio',
  'Profesión u Oficio': 'Profesión u oficio',
  'Pilares': 'Pilares de mentoría',
  'Describe en qué temas generales y específicos puedes aportar en tus mentorías': 'Descripción de temas en que puede aportar',
  'Escribe una mini reseña de ti, que se mostrará en nuestra plataforma': 'Mini reseña',
  '¿Podemos compartir tu información de contacto con mentees y mentores de ChileConverge?': '¿Podemos compartir tu información de contacto?',
  'Último acceso en plataforma': 'Accesos a plataforma',
};

export const getAllowedFieldNames = (tipoReporte = 'custom') => {
  const registryNames = [
    ...CAMPOS_REGISTRO.map((field) => field.name),
    ...HISTORICAL_REGISTRY_FIELD_NAMES,
  ];

  if (tipoReporte === 'register') return registryNames;
  if (tipoReporte === 'activity') return CAMPOS_ACTIVIDAD.map((field) => field.name);
  return [
    ...registryNames,
    ...CAMPOS_ACTIVIDAD.map((field) => field.name),
  ];
};

export const normalizeFieldSelection = (fields, allowedFieldNames = null) => {
  if (!Array.isArray(fields)) return [];

  const allowedSet = allowedFieldNames ? new Set(allowedFieldNames) : null;

  const normalizedNames = fields
    .map((field) => {
      if (typeof field === 'string') return field;
      if (field && typeof field === 'object') return field.name;
      return null;
    })
    .filter(Boolean)
    .map((name) => LEGACY_FIELD_ALIASES[name] || name)
    .filter((name) => !allowedSet || allowedSet.has(name));

  return Array.from(new Set(normalizedNames));
};
